import {Component, ContentChild, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'navaar-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['../tabs/tabs.component.scss']
})
export class TabComponent {
  @Input('Tab-Title') public title: string;
  @Input('Tab-Name') public name: string;
  @ContentChild('table', { static: true }) table;
  @Input() active = false;
  @Input() index = 0;
  @Output() public onClick: EventEmitter<string> = new EventEmitter();

  constructor() { }
}
